// extracted by mini-css-extract-plugin
module.exports = {"featured-image":"FeaturedImage_featured-image__5JS_w"};